import { Record, Map } from "immutable"
import moment from "moment"

import {
    toUI as defaultToUI,
    normaliseModel,
    hydrateModel,
    updateChangeModel,
    updateCreateModel
} from "../model-utils"

export const StakeholderModel = new Record({
    id: "",
    bio: "",
    full_name: "",
    imagePreviewURL: undefined,
    last_updated: moment(),
    photo_url: "",
    primary_organisation: "",
    primary_position: "",
    thumbnail_url: "",
    type: ""
})

export function StakeholderCreateModel() {
    return Map({
        full_name: ""
    })
}

const dateFields = []
const tagFields = []
export const normalisingFields = []

const addRemoveFields = []

export const normalise = stakeholder =>
    normaliseModel(stakeholder, ...normalisingFields)
export const hydrate = (stakeholder, ...entityStates) =>
    hydrateModel(stakeholder, normalisingFields, entityStates)

export const updateStakeholderChangeModel = (
    name,
    value,
    changeModel,
    workingModel
) => updateChangeModel(name, value, changeModel, workingModel, addRemoveFields)

export const updateStakeholderCreateModel = (
    name,
    value,
    createModel,
    workingModel
) => updateCreateModel(name, value, createModel, workingModel)

export const toUI = stakeholder =>
    defaultToUI(stakeholder, dateFields, tagFields)
